import React from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/Layout/Layout";
import Layout2 from "@/components/Layout/Layout2";
import { Button } from "@/components/ui/button";
import { ShieldAlert, Home, ArrowLeft } from "lucide-react";

function AccessDenied() {
  const navigate = useNavigate();

  return (
    // <Layout2>
      <div className="w-full h-full h-screen flex flex-col items-center justify-center bg-color1 p-4">
        <div className="max-w-md w-full bg-cblack3 border border-color3 rounded-2xl p-8 shadow-2xl flex flex-col items-center text-center animate-fadeIn">
          {/* Glowing Shield Alert Icon Container */}
          <div className="flex items-center justify-center w-24 h-24 rounded-full bg-color8/10 mb-6 ring-4 ring-color8/5 animate-pulse">
            <ShieldAlert className="w-12 h-12 text-color8" />
          </div>

          {/* Title */}
          <h1 className="text-3xl font-extrabold text-cwhite tracking-tight mb-3">
            Access Denied
          </h1>

          {/* Subtitle / Description */}
          <p className="text-gray1 text-sm leading-relaxed mb-8 max-w-sm">
            You do not have the required permissions to view this module. If you believe this is an error, please contact your system administrator.
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 w-full justify-center">
            <Button
              variant="outline"
              onClick={() => navigate(-1)}
              className="flex items-center justify-center gap-2 border-color3 text-cwhite hover:bg-color2 px-6 py-2 rounded-xl transition-all duration-300 w-full sm:w-auto"
            >
              <ArrowLeft className="w-4 h-4" />
              Go Back
            </Button>
            <Button
              variant="default"
              onClick={() => navigate("/home")}
              className="flex items-center justify-center gap-2 bg-cyellow text-cblack hover:opacity-90 px-6 py-2 rounded-xl transition-all duration-300 w-full sm:w-auto"
            >
              <Home className="w-4 h-4" />
              Return Home
            </Button>
          </div>
        </div>
      </div>
    // </Layout2>
  );
}

export default AccessDenied;
